<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-lg rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">{{ title }}</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Form -->
    <form [formGroup]="userForm" (ngSubmit)="submit()" class="p-6">
      <div class="space-y-5">
        <!-- Employee ID -->
        <div class="form-group">
          <label for="employeeId" class="form-label">Mitarbeiter-Nr. *</label>
          <input
            type="number"
            id="employeeId"
            formControlName="employeeId"
            class="form-input"
            [class.error]="isFieldInvalid('employeeId')"
            placeholder="z.B. 1001"
          />
          @if (isFieldInvalid('employeeId')) {
            <span class="form-error">{{ getFieldError('employeeId') }}</span>
          }
        </div>

        <!-- Name Row -->
        <div class="grid grid-cols-2 gap-4">
          <!-- First Name -->
          <div class="form-group">
            <label for="firstname" class="form-label">Vorname *</label>
            <input
              type="text"
              id="firstname"
              formControlName="firstname"
              class="form-input"
              [class.error]="isFieldInvalid('firstname')"
              placeholder="Vorname"
            />
            @if (isFieldInvalid('firstname')) {
              <span class="form-error">{{ getFieldError('firstname') }}</span>
            }
          </div>

          <!-- Last Name -->
          <div class="form-group">
            <label for="lastname" class="form-label">Nachname *</label>
            <input
              type="text"
              id="lastname"
              formControlName="lastname"
              class="form-input"
              [class.error]="isFieldInvalid('lastname')"
              placeholder="Nachname"
            />
            @if (isFieldInvalid('lastname')) {
              <span class="form-error">{{ getFieldError('lastname') }}</span>
            }
          </div>
        </div>

        <!-- QR Token (only visible in edit mode) -->
        @if (isEditMode) {
          <div class="form-group">
            <label for="qrToken" class="form-label">QR Token</label>
            <input type="text" id="qrToken" formControlName="qrToken" readonly class="form-input bg-white/4 cursor-not-allowed" />
          </div>
        }

        <!-- Role & State Row -->
        <div class="grid grid-cols-2 gap-4">
          <!-- Role -->
          <div class="form-group">
            <label for="role" class="form-label">Rolle *</label>
            <select id="role" formControlName="role" class="form-input">
              @for (option of roleOptions; track option.value) {
                <option [ngValue]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>

          <!-- State -->
          <div class="form-group">
            <label for="state" class="form-label">Status *</label>
            <select id="state" formControlName="state" class="form-input">
              <option [ngValue]="UserState.ACTIVE">Aktiv</option>
              <option [ngValue]="UserState.DEACTIVATED">Inaktiv</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 mt-8 pt-6 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
        <button type="submit" class="btn-primary px-5 py-2.5 text-sm" [disabled]="isSubmitting">
          @if (isSubmitting) {
            <span class="flex items-center gap-2">
              <span class="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></span>
              Speichern...
            </span>
          } @else {
            {{ isEditMode ? 'Speichern' : 'Hinzufügen' }}
          }
        </button>
      </div>
    </form>
  </div>
</div>
